export default "__VITE_ASSET__dGpu0WHE__"